import React, { useState } from "react";
import AppHeader from "../components/AppHeader";
import { Box, Button, TextField, Typography, Paper } from "@mui/material";
import dayjs from "dayjs";

const API_URL = process.env.REACT_APP_ATTENDANCE_API_URL || "http://localhost:3001/api/attendance";

export default function ExportT2HR() {
  const today = dayjs().format("YYYY-MM-DD");

  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    if (!fromDate || !toDate) {
      alert("Please select date range");
      return;
    }

    setLoading(true);

    try {
      const tenant = localStorage.getItem("tenant") || "";

      const url = `${API_URL}/export-t2hr?date_from=${fromDate}&date_to=${toDate}`;

      const response = await fetch(url, {
        credentials: "include",
        headers: {
          "X-Tenant": tenant,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to export");
      }
      console.log("Tenant:", tenant)
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = `${tenant}_${fromDate}_${toDate}.txt`;
      a.click();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (err) {
      console.error(err);
      alert("Export failed, please try again");
    }

    setLoading(false);
  };

  return (
    <div>
      <AppHeader />

      <Box
        sx={{
          p: 3,
          mt: 2,
          mx: "auto",
          width: "90%",
          maxWidth: "600px",
          backgroundColor: "#ffffff",
          borderRadius: "8px",
        }}
        component={Paper}
      >
        <Typography variant="h5" sx={{ fontWeight: "bold", mb: 3 }}>
          Export Data
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            type="date"
            label="From Date"
            InputLabelProps={{ shrink: true }}
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />

          <TextField
            type="date"
            label="To Date"
            InputLabelProps={{ shrink: true }}
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />

          <Button
            variant="contained"
            sx={{
              backgroundColor: "#2e7d32",
              fontWeight: "bold",
              "&:hover": { backgroundColor: "#1b5e20" },
              mt: 2,
            }}
            onClick={handleExport}
            disabled={loading}
          >
            {loading ? "Exporting..." : "Export"}
          </Button>
        </Box>
      </Box>
    </div>
  );
}